/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_Permissions
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

// Types
export type Calendar_View_Reports = 'Calendar_View_Reports';
export type CenterSignIn_Manage = 'CenterSignIn_Manage';
export type Control_Exams = 'Control_Exams';
export type Course_List_Participant_View = 'Course_List_Participant_View';
export type Course_Monitor_ExamSessions = 'Course_Monitor_ExamSessions';
export type Course_Participant_Manage = 'Course_Participant_Manage';
export type Course_Participant_Manage_View = 'Course_Participant_Manage_View';
export type Course_Participant_Result_View = 'Course_Participant_Result_View';
export type Course_Private_View = 'Course_Private_View';
export type Course_Statistics_Report_View = 'Course_Statistics_Report_View';
export type Course_Total_Grades_View = 'Course_Total_Grades_View';
export type Courses_Agenda_Manage = 'Courses_Agenda_Manage';
export type Courses_Agenda_View = 'Courses_Agenda_View';
export type Courses_Archive = 'Courses_Archive';
export type Courses_Create = 'Courses_Create';
export type Courses_Curriculum_Manage = 'Courses_Curriculum_Manage';
export type Courses_Edit = 'Courses_Edit';
export type Courses_Export = 'Courses_Export';
export type Courses_Import = 'Courses_Import';
export type CoursesList_View = 'CoursesList_View';
export type Courses_People_ChangeContributors = 'Courses_People_ChangeContributors';
export type Courses_People_ChangeMonitors = 'Courses_People_ChangeMonitors';
export type Courses_People_ChangeOwner = 'Courses_People_ChangeOwner';
export type Courses_People_ChangeViewers = 'Courses_People_ChangeViewers';
export type Courses_Results_Manage = 'Courses_Results_Manage';
export type Courses_Results_View = 'Courses_Results_View';
export type Courses_View = 'Courses_View';
export type DashboardInsights_View = 'DashboardInsights_View';
export type DashboardReports_View = 'DashboardReports_View';
export type Evaluation_Complete = 'Evaluation_Complete';
export type Evaluation_Create = 'Evaluation_Create';
export type Evaluation_Edit = 'Evaluation_Edit';
export type Evaluation_Grades_View = 'Evaluation_Grades_View';
export type EvaluationTemplate_Fill_View = 'EvaluationTemplate_Fill_View';
export type Evaluation_View = 'Evaluation_View';
export type Exam_Evaluation_List = 'Exam_Evaluation_List';
export type HelpAdmin_View = 'HelpAdmin_View';
export type Monitor_ExamSessions = 'Monitor_ExamSessions';
export type Organization_View = 'Organization_View';
export type Participants_ChangePassword = 'Participants_ChangePassword';
export type Participants_Create = 'Participants_Create';
export type Participants_Edit = 'Participants_Edit';
export type Participants_Import = 'Participants_Import';
export type ProfileContact_Edit = 'ProfileContact_Edit';
export type Report_Course_View = 'Report_Course_View';
export type ReportsAnnotation_View = 'ReportsAnnotation_View';
export type Reports_Organization_View = 'Reports_Organization_View';
export type Reports_ReportOn_AnswerGrades = 'Reports_ReportOn_AnswerGrades';
export type Reports_ReportOn_SessionAnnotations = 'Reports_ReportOn_SessionAnnotations';
export type Reports_ReportOn_Sessions = 'Reports_ReportOn_Sessions';
export type Reports_Scenario_View = 'Reports_Scenario_View';
export type Reports_Sessions_View = 'Reports_Sessions_View';
export type ReportsUsage_View = 'ReportsUsage_View';
export type Reservation_Requests_Delete = 'Reservation_Requests_Delete';
export type Reservation_Requests_List = 'Reservation_Requests_List';
export type Reservation_Requests_View = 'Reservation_Requests_View';
export type Reservations_Create = 'Reservations_Create';
export type Reservations_Edit = 'Reservations_Edit';
export type Reservations_List = 'Reservations_List';
export type Reservations_Private_View = 'Reservations_Private_View';
export type Reservations_Request = 'Reservations_Request';
export type Reservations_View = 'Reservations_View';
export type Scenario_Evaluation_Results_View = 'Scenario_Evaluation_Results_View';
export type Scenario_Evaluation_Template_Manage = 'Scenario_Evaluation_Template_Manage';
export type Scenario_Private_View = 'Scenario_Private_View';
export type ScenariosAnnotations_Edit = 'ScenariosAnnotations_Edit';
export type Scenarios_Archive = 'Scenarios_Archive';
export type ScenariosAttachments_Upload = 'ScenariosAttachments_Upload';
export type Scenarios_Create = 'Scenarios_Create';
export type Scenarios_Edit = 'Scenarios_Edit';
export type Scenarios_Export = 'Scenarios_Export';
export type Scenarios_Import = 'Scenarios_Import';
export type ScenariosList_View = 'ScenariosList_View';
export type ScenariosPeople_ChangeContributor = 'ScenariosPeople_ChangeContributor';
export type ScenariosPeople_ChangeOwner = 'ScenariosPeople_ChangeOwner';
export type ScenariosPeople_ChangeViewers = 'ScenariosPeople_ChangeViewers';
export type Scenarios_View = 'Scenarios_View';
export type Scoring_Evaluation_Complete = 'Scoring_Evaluation_Complete';
export type Scoring_Evaluation_Create = 'Scoring_Evaluation_Create';
export type Scoring_Evaluation_Edit = 'Scoring_Evaluation_Edit';
export type Scoring_Evaluation_View = 'Scoring_Evaluation_View';
export type Scoring_Rubric_Fill_View = 'Scoring_Rubric_Fill_View';
export type Session_JoinLive = 'Session_JoinLive';
export type Session_Link_Manage = 'Session_Link_Manage';
export type Session_List_Live = 'Session_List_Live';
export type Session_Ptz_Manage = 'Session_Ptz_Manage';
export type Session_Start_Course = 'Session_Start_Course';
export type Session_Start_Scenario = 'Session_Start_Scenario';
export type Session_Stop = 'Session_Stop';
export type Sessions_Admin_Evaluations_Create = 'Sessions_Admin_Evaluations_Create';
export type Sessions_Create = 'Sessions_Create';
export type Sessions_Delete = 'Sessions_Delete';
export type Sessions_Download = 'Sessions_Download';
export type Sessions_Evaluation_List = 'Sessions_Evaluation_List';
export type Sessions_Evaluation_Results_View = 'Sessions_Evaluation_Results_View';
export type Sessions_Import = 'Sessions_Import';
export type SessionsList_View = 'SessionsList_View';
export type Sessions_View = 'Sessions_View';
export type Sps_Create = 'Sps_Create';
export type Sps_Designate = 'Sps_Designate';
export type Sps_Edit_Demographics = 'Sps_Edit_Demographics';
export type Sps_Import = 'Sps_Import';
export type Sps_View_Demographics = 'Sps_View_Demographics';
export type SV_People_ChangeContributor = 'SV_People_ChangeContributor';
export type SV_People_ChangeOwner = 'SV_People_ChangeOwner';
export type SV_People_ChangeParticipant = 'SV_People_ChangeParticipant';
export type SV_People_ChangePatient = 'SV_People_ChangePatient';
export type SV_People_ChangeViewers = 'SV_People_ChangeViewers';
export type SV_People_CreateExternalLink = 'SV_People_CreateExternalLink';
export type SV_People_View = 'SV_People_View';
export type SV_RecordingAnnotations_Create = 'SV_RecordingAnnotations_Create';
export type SV_RecordingAnnotations_Edit = 'SV_RecordingAnnotations_Edit';
export type SV_RecordingAnnotations_List = 'SV_RecordingAnnotations_List';
export type SV_RecordingAnnotations_View = 'SV_RecordingAnnotations_View';
export type SV_SimData_Import = 'SV_SimData_Import';
export type SV_Summary_Edit = 'SV_Summary_Edit';
export type SystemSetup_View = 'SystemSetup_View';
export type UserRole_View = 'UserRole_View';
export type Users_ChangePassword = 'Users_ChangePassword';
export type Users_ChangeRole = 'Users_ChangeRole';
export type Users_Create = 'Users_Create';
export type Users_Edit = 'Users_Edit';
export type Users_Export = 'Users_Export';
export type Users_Import = 'Users_Import';
export type UsersList_View = 'UsersList_View';
export type UsersSettings_Edit = 'UsersSettings_Edit';
export type Users_View = 'Users_View';

export type Permission =
    | Calendar_View_Reports
    | CenterSignIn_Manage
    | Control_Exams
    | Course_List_Participant_View
    | Course_Monitor_ExamSessions
    | Course_Participant_Manage
    | Course_Participant_Manage_View
    | Course_Participant_Result_View
    | Course_Private_View
    | Course_Statistics_Report_View
    | Course_Total_Grades_View
    | Courses_Agenda_Manage
    | Courses_Agenda_View
    | Courses_Archive
    | Courses_Create
    | Courses_Curriculum_Manage
    | Courses_Edit
    | Courses_Export
    | Courses_Import
    | CoursesList_View
    | Courses_People_ChangeContributors
    | Courses_People_ChangeMonitors
    | Courses_People_ChangeOwner
    | Courses_People_ChangeViewers
    | Courses_Results_Manage
    | Courses_Results_View
    | Courses_View
    | DashboardInsights_View
    | DashboardReports_View
    | Evaluation_Complete
    | Evaluation_Create
    | Evaluation_Edit
    | Evaluation_Grades_View
    | EvaluationTemplate_Fill_View
    | Evaluation_View
    | Exam_Evaluation_List
    | HelpAdmin_View
    | Monitor_ExamSessions
    | Organization_View
    | Participants_ChangePassword
    | Participants_Create
    | Participants_Edit
    | Participants_Import
    | ProfileContact_Edit
    | Report_Course_View
    | ReportsAnnotation_View
    | Reports_Organization_View
    | Reports_ReportOn_AnswerGrades
    | Reports_ReportOn_SessionAnnotations
    | Reports_ReportOn_Sessions
    | Reports_Scenario_View
    | Reports_Sessions_View
    | ReportsUsage_View
    | Reservation_Requests_Delete
    | Reservation_Requests_List
    | Reservation_Requests_View
    | Reservations_Create
    | Reservations_Edit
    | Reservations_List
    | Reservations_Private_View
    | Reservations_Request
    | Reservations_View
    | Scenario_Evaluation_Results_View
    | Scenario_Evaluation_Template_Manage
    | Scenario_Private_View
    | ScenariosAnnotations_Edit
    | Scenarios_Archive
    | ScenariosAttachments_Upload
    | Scenarios_Create
    | Scenarios_Edit
    | Scenarios_Export
    | Scenarios_Import
    | ScenariosList_View
    | ScenariosPeople_ChangeContributor
    | ScenariosPeople_ChangeOwner
    | ScenariosPeople_ChangeViewers
    | Scenarios_View
    | Scoring_Evaluation_Complete
    | Scoring_Evaluation_Create
    | Scoring_Evaluation_Edit
    | Scoring_Evaluation_View
    | Scoring_Rubric_Fill_View
    | Session_JoinLive
    | Session_Link_Manage
    | Session_List_Live
    | Session_Ptz_Manage
    | Session_Start_Course
    | Session_Start_Scenario
    | Session_Stop
    | Sessions_Admin_Evaluations_Create
    | Sessions_Create
    | Sessions_Delete
    | Sessions_Download
    | Sessions_Evaluation_List
    | Sessions_Evaluation_Results_View
    | Sessions_Import
    | SessionsList_View
    | Sessions_View
    | Sps_Create
    | Sps_Designate
    | Sps_Edit_Demographics
    | Sps_Import
    | Sps_View_Demographics
    | SV_People_ChangeContributor
    | SV_People_ChangeOwner
    | SV_People_ChangeParticipant
    | SV_People_ChangePatient
    | SV_People_ChangeViewers
    | SV_People_CreateExternalLink
    | SV_People_View
    | SV_RecordingAnnotations_Create
    | SV_RecordingAnnotations_Edit
    | SV_RecordingAnnotations_List
    | SV_RecordingAnnotations_View
    | SV_SimData_Import
    | SV_Summary_Edit
    | SystemSetup_View
    | UserRole_View
    | Users_ChangePassword
    | Users_ChangeRole
    | Users_Create
    | Users_Edit
    | Users_Export
    | Users_Import
    | UsersList_View
    | UsersSettings_Edit
    | Users_View;

// Constants
export const CALENDAR_VIEW_REPORTS: Permission = 'Calendar_View_Reports' as const;
export const CENTER_SIGN_IN_MANAGE: Permission = 'CenterSignIn_Manage' as const;
export const CONTROL_EXAMS: Permission = 'Control_Exams' as const;
export const COURSE_LIST_PARTICIPANT_VIEW: Permission = 'Course_List_Participant_View' as const;
export const COURSE_MONITOR_EXAM_SESSIONS: Permission = 'Course_Monitor_ExamSessions' as const;
export const COURSE_PARTICIPANT_MANAGE: Permission = 'Course_Participant_Manage' as const;
export const COURSE_PARTICIPANT_MANAGE_VIEW: Permission = 'Course_Participant_Manage_View' as const;
export const COURSE_PARTICIPANT_RESULT_VIEW: Permission = 'Course_Participant_Result_View' as const;
export const COURSE_PRIVATE_VIEW: Permission = 'Course_Private_View' as const;
export const COURSE_STATISTICS_REPORT_VIEW: Permission = 'Course_Statistics_Report_View' as const;
export const COURSE_TOTAL_GRADES_VIEW: Permission = 'Course_Total_Grades_View' as const;
export const COURSES_AGENDA_MANAGE: Permission = 'Courses_Agenda_Manage' as const;
export const COURSES_AGENDA_VIEW: Permission = 'Courses_Agenda_View' as const;
export const COURSES_ARCHIVE: Permission = 'Courses_Archive' as const;
export const COURSES_CREATE: Permission = 'Courses_Create' as const;
export const COURSES_CURRICULUM_MANAGE: Permission = 'Courses_Curriculum_Manage' as const;
export const COURSES_EDIT: Permission = 'Courses_Edit' as const;
export const COURSES_EXPORT: Permission = 'Courses_Export' as const;
export const COURSES_IMPORT: Permission = 'Courses_Import' as const;
export const COURSES_LIST_VIEW: Permission = 'CoursesList_View' as const;
export const COURSES_PEOPLE_CHANGE_CONTRIBUTORS: Permission = 'Courses_People_ChangeContributors' as const;
export const COURSES_PEOPLE_CHANGE_MONITORS: Permission = 'Courses_People_ChangeMonitors' as const;
export const COURSES_PEOPLE_CHANGE_OWNER: Permission = 'Courses_People_ChangeOwner' as const;
export const COURSES_PEOPLE_CHANGE_VIEWERS: Permission = 'Courses_People_ChangeViewers' as const;
export const COURSES_RESULTS_MANAGE: Permission = 'Courses_Results_Manage' as const;
export const COURSES_RESULTS_VIEW: Permission = 'Courses_Results_View' as const;
export const COURSES_VIEW: Permission = 'Courses_View' as const;
export const DASHBOARD_INSIGHTS_VIEW: Permission = 'DashboardInsights_View' as const;
export const DASHBOARD_REPORTS_VIEW: Permission = 'DashboardReports_View' as const;
export const EVALUATION_COMPLETE: Permission = 'Evaluation_Complete' as const;
export const EVALUATION_CREATE: Permission = 'Evaluation_Create' as const;
export const EVALUATION_EDIT: Permission = 'Evaluation_Edit' as const;
export const EVALUATION_GRADES_VIEW: Permission = 'Evaluation_Grades_View' as const;
export const EVALUATION_TEMPLATE_FILL_VIEW: Permission = 'EvaluationTemplate_Fill_View' as const;
export const EVALUATION_VIEW: Permission = 'Evaluation_View' as const;
export const EXAM_EVALUATION_LIST: Permission = 'Exam_Evaluation_List' as const;
export const HELP_ADMIN_VIEW: Permission = 'HelpAdmin_View' as const;
export const MONITOR_EXAM_SESSIONS: Permission = 'Monitor_ExamSessions' as const;
export const ORGANIZATION_VIEW: Permission = 'Organization_View' as const;
export const PARTICIPANTS_CHANGE_PASSWORD: Permission = 'Participants_ChangePassword' as const;
export const PARTICIPANTS_CREATE: Permission = 'Participants_Create' as const;
export const PARTICIPANTS_EDIT: Permission = 'Participants_Edit' as const;
export const PARTICIPANTS_IMPORT: Permission = 'Participants_Import' as const;
export const PROFILE_CONTACT_EDIT: Permission = 'ProfileContact_Edit' as const;
export const REPORT_COURSE_VIEW: Permission = 'Report_Course_View' as const;
export const REPORTS_ANNOTATION_VIEW: Permission = 'ReportsAnnotation_View' as const;
export const REPORTS_ORGANIZATION_VIEW: Permission = 'Reports_Organization_View' as const;
export const REPORTS_REPORT_ON_ANSWER_GRADES: Permission = 'Reports_ReportOn_AnswerGrades' as const;
export const REPORTS_REPORT_ON_SESSION_ANNOTATIONS: Permission = 'Reports_ReportOn_SessionAnnotations' as const;
export const REPORTS_REPORT_ON_SESSIONS: Permission = 'Reports_ReportOn_Sessions' as const;
export const REPORTS_SCENARIO_VIEW: Permission = 'Reports_Scenario_View' as const;
export const REPORTS_SESSIONS_VIEW: Permission = 'Reports_Sessions_View' as const;
export const REPORTS_USAGE_VIEW: Permission = 'ReportsUsage_View' as const;
export const RESERVATION_REQUESTS_DELETE: Permission = 'Reservation_Requests_Delete' as const;
export const RESERVATION_REQUESTS_LIST: Permission = 'Reservation_Requests_List' as const;
export const RESERVATION_REQUESTS_VIEW: Permission = 'Reservation_Requests_View' as const;
export const RESERVATIONS_CREATE: Permission = 'Reservations_Create' as const;
export const RESERVATIONS_EDIT: Permission = 'Reservations_Edit' as const;
export const RESERVATIONS_LIST: Permission = 'Reservations_List' as const;
export const RESERVATIONS_PRIVATE_VIEW: Permission = 'Reservations_Private_View' as const;
export const RESERVATIONS_REQUEST: Permission = 'Reservations_Request' as const;
export const RESERVATIONS_VIEW: Permission = 'Reservations_View' as const;
export const SCENARIO_EVALUATION_RESULTS_VIEW: Permission = 'Scenario_Evaluation_Results_View' as const;
export const SCENARIO_EVALUATION_TEMPLATE_MANAGE: Permission = 'Scenario_Evaluation_Template_Manage' as const;
export const SCENARIO_PRIVATE_VIEW: Permission = 'Scenario_Private_View' as const;
export const SCENARIOS_ANNOTATIONS_EDIT: Permission = 'ScenariosAnnotations_Edit' as const;
export const SCENARIOS_ARCHIVE: Permission = 'Scenarios_Archive' as const;
export const SCENARIOS_ATTACHMENTS_UPLOAD: Permission = 'ScenariosAttachments_Upload' as const;
export const SCENARIOS_CREATE: Permission = 'Scenarios_Create' as const;
export const SCENARIOS_EDIT: Permission = 'Scenarios_Edit' as const;
export const SCENARIOS_EXPORT: Permission = 'Scenarios_Export' as const;
export const SCENARIOS_IMPORT: Permission = 'Scenarios_Import' as const;
export const SCENARIOS_LIST_VIEW: Permission = 'ScenariosList_View' as const;
export const SCENARIOS_PEOPLE_CHANGE_CONTRIBUTOR: Permission = 'ScenariosPeople_ChangeContributor' as const;
export const SCENARIOS_PEOPLE_CHANGE_OWNER: Permission = 'ScenariosPeople_ChangeOwner' as const;
export const SCENARIOS_PEOPLE_CHANGE_VIEWERS: Permission = 'ScenariosPeople_ChangeViewers' as const;
export const SCENARIOS_VIEW: Permission = 'Scenarios_View' as const;
export const SCORING_EVALUATION_COMPLETE: Permission = 'Scoring_Evaluation_Complete' as const;
export const SCORING_EVALUATION_CREATE: Permission = 'Scoring_Evaluation_Create' as const;
export const SCORING_EVALUATION_EDIT: Permission = 'Scoring_Evaluation_Edit' as const;
export const SCORING_EVALUATION_VIEW: Permission = 'Scoring_Evaluation_View' as const;
export const SCORING_RUBRIC_FILL_VIEW: Permission = 'Scoring_Rubric_Fill_View' as const;
export const SESSION_JOIN_LIVE: Permission = 'Session_JoinLive' as const;
export const SESSION_LINK_MANAGE: Permission = 'Session_Link_Manage' as const;
export const SESSION_LIST_LIVE: Permission = 'Session_List_Live' as const;
export const SESSION_PTZ_MANAGE: Permission = 'Session_Ptz_Manage' as const;
export const SESSION_START_COURSE: Permission = 'Session_Start_Course' as const;
export const SESSION_START_SCENARIO: Permission = 'Session_Start_Scenario' as const;
export const SESSION_STOP: Permission = 'Session_Stop' as const;
export const SESSIONS_ADMIN_EVALUATIONS_CREATE: Permission = 'Sessions_Admin_Evaluations_Create' as const;
export const SESSIONS_CREATE: Permission = 'Sessions_Create' as const;
export const SESSIONS_DELETE: Permission = 'Sessions_Delete' as const;
export const SESSIONS_DOWNLOAD: Permission = 'Sessions_Download' as const;
export const SESSIONS_EVALUATION_LIST: Permission = 'Sessions_Evaluation_List' as const;
export const SESSIONS_EVALUATION_RESULTS_VIEW: Permission = 'Sessions_Evaluation_Results_View' as const;
export const SESSIONS_IMPORT: Permission = 'Sessions_Import' as const;
export const SESSIONS_LIST_VIEW: Permission = 'SessionsList_View' as const;
export const SESSIONS_VIEW: Permission = 'Sessions_View' as const;
export const SPS_CREATE: Permission = 'Sps_Create' as const;
export const SPS_DESIGNATE: Permission = 'Sps_Designate' as const;
export const SPS_EDIT_DEMOGRAPHICS: Permission = 'Sps_Edit_Demographics' as const;
export const SPS_IMPORT: Permission = 'Sps_Import' as const;
export const SPS_VIEW_DEMOGRAPHICS: Permission = 'Sps_View_Demographics' as const;
export const SV_PEOPLE_CHANGE_CONTRIBUTOR: Permission = 'SV_People_ChangeContributor' as const;
export const SV_PEOPLE_CHANGE_OWNER: Permission = 'SV_People_ChangeOwner' as const;
export const SV_PEOPLE_CHANGE_PARTICIPANT: Permission = 'SV_People_ChangeParticipant' as const;
export const SV_PEOPLE_CHANGE_PATIENT: Permission = 'SV_People_ChangePatient' as const;
export const SV_PEOPLE_CHANGE_VIEWERS: Permission = 'SV_People_ChangeViewers' as const;
export const SV_PEOPLE_CREATE_EXTERNAL_LINK: Permission = 'SV_People_CreateExternalLink' as const;
export const SV_PEOPLE_VIEW: Permission = 'SV_People_View' as const;
export const SV_RECORDING_ANNOTATIONS_CREATE: Permission = 'SV_RecordingAnnotations_Create' as const;
export const SV_RECORDING_ANNOTATIONS_EDIT: Permission = 'SV_RecordingAnnotations_Edit' as const;
export const SV_RECORDING_ANNOTATIONS_LIST: Permission = 'SV_RecordingAnnotations_List' as const;
export const SV_RECORDING_ANNOTATIONS_VIEW: Permission = 'SV_RecordingAnnotations_View' as const;
export const SV_SIM_DATA_IMPORT: Permission = 'SV_SimData_Import' as const;
export const SV_SUMMARY_EDIT: Permission = 'SV_Summary_Edit' as const;
export const SYSTEM_SETUP_VIEW: Permission = 'SystemSetup_View' as const;
export const USER_ROLE_VIEW: Permission = 'UserRole_View' as const;
export const USERS_CHANGE_PASSWORD: Permission = 'Users_ChangePassword' as const;
export const USERS_CHANGE_ROLE: Permission = 'Users_ChangeRole' as const;
export const USERS_CREATE: Permission = 'Users_Create' as const;
export const USERS_EDIT: Permission = 'Users_Edit' as const;
export const USERS_EXPORT: Permission = 'Users_Export' as const;
export const USERS_IMPORT: Permission = 'Users_Import' as const;
export const USERS_LIST_VIEW: Permission = 'UsersList_View' as const;
export const USERS_SETTINGS_EDIT: Permission = 'UsersSettings_Edit' as const;
export const USERS_VIEW: Permission = 'Users_View' as const;

const LU_Permissions = {
    CALENDAR_VIEW_REPORTS,
    CENTER_SIGN_IN_MANAGE,
    CONTROL_EXAMS,
    COURSE_LIST_PARTICIPANT_VIEW,
    COURSE_MONITOR_EXAM_SESSIONS,
    COURSE_PARTICIPANT_MANAGE,
    COURSE_PARTICIPANT_MANAGE_VIEW,
    COURSE_PARTICIPANT_RESULT_VIEW,
    COURSE_PRIVATE_VIEW,
    COURSE_STATISTICS_REPORT_VIEW,
    COURSE_TOTAL_GRADES_VIEW,
    COURSES_AGENDA_MANAGE,
    COURSES_AGENDA_VIEW,
    COURSES_ARCHIVE,
    COURSES_CREATE,
    COURSES_CURRICULUM_MANAGE,
    COURSES_EDIT,
    COURSES_EXPORT,
    COURSES_IMPORT,
    COURSES_LIST_VIEW,
    COURSES_PEOPLE_CHANGE_CONTRIBUTORS,
    COURSES_PEOPLE_CHANGE_MONITORS,
    COURSES_PEOPLE_CHANGE_OWNER,
    COURSES_PEOPLE_CHANGE_VIEWERS,
    COURSES_RESULTS_MANAGE,
    COURSES_RESULTS_VIEW,
    COURSES_VIEW,
    DASHBOARD_INSIGHTS_VIEW,
    DASHBOARD_REPORTS_VIEW,
    EVALUATION_COMPLETE,
    EVALUATION_CREATE,
    EVALUATION_EDIT,
    EVALUATION_GRADES_VIEW,
    EVALUATION_TEMPLATE_FILL_VIEW,
    EVALUATION_VIEW,
    EXAM_EVALUATION_LIST,
    HELP_ADMIN_VIEW,
    MONITOR_EXAM_SESSIONS,
    ORGANIZATION_VIEW,
    PARTICIPANTS_CHANGE_PASSWORD,
    PARTICIPANTS_CREATE,
    PARTICIPANTS_EDIT,
    PARTICIPANTS_IMPORT,
    PROFILE_CONTACT_EDIT,
    REPORT_COURSE_VIEW,
    REPORTS_ANNOTATION_VIEW,
    REPORTS_ORGANIZATION_VIEW,
    REPORTS_REPORT_ON_ANSWER_GRADES,
    REPORTS_REPORT_ON_SESSION_ANNOTATIONS,
    REPORTS_REPORT_ON_SESSIONS,
    REPORTS_SCENARIO_VIEW,
    REPORTS_SESSIONS_VIEW,
    REPORTS_USAGE_VIEW,
    RESERVATION_REQUESTS_DELETE,
    RESERVATION_REQUESTS_LIST,
    RESERVATION_REQUESTS_VIEW,
    RESERVATIONS_CREATE,
    RESERVATIONS_EDIT,
    RESERVATIONS_LIST,
    RESERVATIONS_PRIVATE_VIEW,
    RESERVATIONS_REQUEST,
    RESERVATIONS_VIEW,
    SCENARIO_EVALUATION_RESULTS_VIEW,
    SCENARIO_EVALUATION_TEMPLATE_MANAGE,
    SCENARIO_PRIVATE_VIEW,
    SCENARIOS_ANNOTATIONS_EDIT,
    SCENARIOS_ARCHIVE,
    SCENARIOS_ATTACHMENTS_UPLOAD,
    SCENARIOS_CREATE,
    SCENARIOS_EDIT,
    SCENARIOS_EXPORT,
    SCENARIOS_IMPORT,
    SCENARIOS_LIST_VIEW,
    SCENARIOS_PEOPLE_CHANGE_CONTRIBUTOR,
    SCENARIOS_PEOPLE_CHANGE_OWNER,
    SCENARIOS_PEOPLE_CHANGE_VIEWERS,
    SCENARIOS_VIEW,
    SCORING_EVALUATION_COMPLETE,
    SCORING_EVALUATION_CREATE,
    SCORING_EVALUATION_EDIT,
    SCORING_EVALUATION_VIEW,
    SCORING_RUBRIC_FILL_VIEW,
    SESSION_JOIN_LIVE,
    SESSION_LINK_MANAGE,
    SESSION_LIST_LIVE,
    SESSION_PTZ_MANAGE,
    SESSION_START_COURSE,
    SESSION_START_SCENARIO,
    SESSION_STOP,
    SESSIONS_ADMIN_EVALUATIONS_CREATE,
    SESSIONS_CREATE,
    SESSIONS_DELETE,
    SESSIONS_DOWNLOAD,
    SESSIONS_EVALUATION_LIST,
    SESSIONS_EVALUATION_RESULTS_VIEW,
    SESSIONS_IMPORT,
    SESSIONS_LIST_VIEW,
    SESSIONS_VIEW,
    SPS_CREATE,
    SPS_DESIGNATE,
    SPS_EDIT_DEMOGRAPHICS,
    SPS_IMPORT,
    SPS_VIEW_DEMOGRAPHICS,
    SV_PEOPLE_CHANGE_CONTRIBUTOR,
    SV_PEOPLE_CHANGE_OWNER,
    SV_PEOPLE_CHANGE_PARTICIPANT,
    SV_PEOPLE_CHANGE_PATIENT,
    SV_PEOPLE_CHANGE_VIEWERS,
    SV_PEOPLE_CREATE_EXTERNAL_LINK,
    SV_PEOPLE_VIEW,
    SV_RECORDING_ANNOTATIONS_CREATE,
    SV_RECORDING_ANNOTATIONS_EDIT,
    SV_RECORDING_ANNOTATIONS_LIST,
    SV_RECORDING_ANNOTATIONS_VIEW,
    SV_SIM_DATA_IMPORT,
    SV_SUMMARY_EDIT,
    SYSTEM_SETUP_VIEW,
    USER_ROLE_VIEW,
    USERS_CHANGE_PASSWORD,
    USERS_CHANGE_ROLE,
    USERS_CREATE,
    USERS_EDIT,
    USERS_EXPORT,
    USERS_IMPORT,
    USERS_LIST_VIEW,
    USERS_SETTINGS_EDIT,
    USERS_VIEW,
} as const;

export default LU_Permissions;
